import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    stepperContainer: {
      padding: theme.spacing(5, 2, 0),

      '& .MuiStepConnector-line': {
        margin: '0 1rem',
      },
    },
  }),
)
